<template>
  <b-container>
    <b-card
      class="mt-2"
      title="Calibrated curve"
      sub-title="Visualize the curves"
    >
      <b-row>
        <b-col>
          <b-form class="mt-2" inline>
            <label class="sr-only" for="inline-form-input-name">Name</label>
            <b-form-select v-model="selected" :options="curves"></b-form-select>

            <b-button class="ml-2" variant="primary" @click="getCurve"
              >Load</b-button
            >
          </b-form>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="loaded">
        <b-col>
          <b-card>
            <pair title="Curve Name" :value="curve.name" />
            <pair title="Interpolation" :value="curve.interpolator" />
            <pair title="Left extrapolation" :value="curve.extrapolatorLeft" />
            <pair
              title="Right extrapolation"
              :value="curve.extrapolatorRight"
            />
            <Plotly
              :data="data"
              :layout="layout"
              :display-mode-bar="false"
            ></Plotly>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { Plotly } from "vue-plotly";
import { styledLayout } from "@/utils/plotlyLayout.js";

export default {
  data() {
    return {
      curves: [],
      selected: null,
      loaded: false,
      curve: null,
      data: [
        {
          x: [],
          y: [],
          type: "scatter"
        }
      ],
      layout: styledLayout({
        title: ""
      })
    };
  },
  async mounted() {
    this.curves = await this.$client.getCurveNames();
  },
  methods: {
    async getCurve() {
      try {
        const curves = await this.$client.getCurve(this.selected);
        if (curves.length > 0) {
          this.curve = curves[0];
          this.data[0].x = this.curve.xs;
          this.data[0].y = this.curve.ys;
          this.layout.title = this.selected;

          this.loaded = true;
        } else {
          this.loaded = false;
        }
      } catch (e) {
        this.loaded = false;
      }
    }
  },
  components: {
    Plotly
  }
};
</script>
